export const GUIDE_MINUTE = 60000;
export const GUIDE_WINDOW_MS = 3 * 60 * GUIDE_MINUTE;
export const guideWindowStart = (at = Date.now()) => Math.floor(at / (30 * GUIDE_MINUTE)) * 30 * GUIDE_MINUTE - 30 * GUIDE_MINUTE;
export const guideWindowQuery = (start) => ({ startsAt: new Date(start).toISOString(), endsAt: new Date(start + GUIDE_WINDOW_MS).toISOString() });
// Full programme arrays are authoritative, including an explicitly empty window.
// Keep Now/Next fallback for older responses which do not include an array.
export function guideProgrammes(channel) {
  return Array.isArray(channel.programmes) ? channel.programmes : [channel.now, channel.next].filter(Boolean);
}
